module.exports = __webpack_public_path__ + "img/im_dinner@2x.2e3b9422.png";